import { api } from "./axios";
import { PHYLLO_USERID, PHYLLO_TOKEN } from "./constants";

const URL_CREATE_USER_TOKEN = "/v1/sdk-tokens";
const URL_CREATE_USER = "/v1/users";

export const createUser = async (name, externalId) => {
  try {
    const userId = sessionStorage.getItem(PHYLLO_USERID);
    if (userId) {
      return userId;
    } else {
      let response = await api().post(URL_CREATE_USER, {
        name: name,
        external_id: externalId,
      });
      await sessionStorage.setItem(PHYLLO_USERID, response.data.id);
      return response.data.id;
    }
  } catch (err) {
    console.error(`Error ${err} occurred while generating user token`);
    return err.body;
  }
};

export const createUserToken = async (userId) => {
  if (!userId) {
    let err = new Error("User id cannot be blank or null");
    throw err;
  }
  try {
    let response = await api().post(URL_CREATE_USER_TOKEN, {
      user_id: userId,
      products: [
        "IDENTITY",
        "ENGAGEMENT",
        "INCOME",
        "IDENTITY.AUDIENCE",
        "PUBLISH.CONTENT",
        "ENGAGEMENT.AUDIENCE",
        "ACTIVITY"
      ],
    });
    await sessionStorage.setItem(PHYLLO_TOKEN, response.data.sdk_token);
    return response.data.sdk_token;
  } catch (err) {
    console.error(`Error ${err} occurred while generating user token`);
    return err.body;
  }
};
